module.exports = __webpack_public_path__ + "static/media/stmargarets.3ba37db2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/clientes/stmargarets.jpg
// module id = 153
// module chunks = 0